import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { RenewalDto } from '../../renewals.types';

export const RENEWALS_SETUP_QUERY_KEY = 'RENEWALS_SETUP_BY_ID';

const useGetRenewalSetupByPlanYearIdQuery = (id: string) => {
  const { data, isSuccess, isLoading, isError, refetch } = useQuery(
    [RENEWALS_SETUP_QUERY_KEY, id],
    () => api.get<RenewalDto>(API_URL.RENEWALS_PLAN_YEAR_BY_PLAN_YEAR_ID(id)),
    {
      enabled: !!id,
      retry: false,
    }
  );

  return {
    isLoading,
    isSuccess,
    isError,
    data: data?.data,
    refetch,
  };
};

export default useGetRenewalSetupByPlanYearIdQuery;
